<template>
  <div class="dashboard">
    <el-row :gutter="24" class="stats-row">
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-content">
            <div class="stat-info">
              <p class="stat-label">今日订单数</p>
              <h3 class="stat-value">{{ stats.todayOrders || 0 }}</h3>
              <p class="stat-trend up" v-if="stats.orderTrend > 0">
                <i class="el-icon-top"></i> +{{ stats.orderTrend }}% 较昨日
              </p>
            </div>
            <div class="stat-icon red">
              <i class="el-icon-shopping-cart-2"></i>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-content">
            <div class="stat-info">
              <p class="stat-label">本月营业额</p>
              <h3 class="stat-value">&yen; {{ formatMoney(stats.monthAmount) }}</h3>
              <p class="stat-trend up" v-if="stats.amountTrend > 0">
                <i class="el-icon-top"></i> +{{ stats.amountTrend }}% 较上月
              </p>
            </div>
            <div class="stat-icon blue">
              <i class="el-icon-money"></i>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-content">
            <div class="stat-info">
              <p class="stat-label">本域会员总数</p>
              <h3 class="stat-value">{{ stats.memberCount || 0 }}</h3>
              <p class="stat-sub">覆盖业务经理 {{ stats.managerCount || 0 }} 位</p>
            </div>
            <div class="stat-icon orange">
              <i class="el-icon-user-solid"></i>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-content">
            <div class="stat-info">
              <p class="stat-label">欠平台费用</p>
              <h3 class="stat-value red-text">&yen; {{ formatMoney(stats.platformDebts) }}</h3>
              <p class="stat-link" @click="$router.push('/debt-detail')">查看流水 &gt;</p>
            </div>
            <div class="stat-icon purple">
              <i class="el-icon-wallet"></i>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24" class="chart-row">
      <el-col :span="16">
        <el-card class="chart-card">
          <div slot="header" class="card-header">
            <span>近7日销售额趋势</span>
          </div>
          <div ref="salesChart" class="chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="order-card">
          <div slot="header" class="card-header">
            <span>最新订单</span>
            <el-button type="text" size="small" @click="$router.push('/orders')">全部订单</el-button>
          </div>
          <div class="order-list" v-if="recentOrders.length">
            <div class="order-item" v-for="item in recentOrders" :key="item.id">
              <div class="order-left">
                <el-image :src="item.goods_img" class="order-img" fit="cover" />
                <div class="order-info">
                  <p class="order-name">{{ item.goods_name }}</p>
                  <p class="order-no">订单: {{ item.order_no }}</p>
                </div>
              </div>
              <div class="order-right">
                <p class="order-price">&yen; {{ item.total_amount }}</p>
                <el-tag :type="statusType(item.status)" size="mini">{{ item.status_text }}</el-tag>
              </div>
            </div>
          </div>
          <el-empty v-else description="暂无订单" :image-size="80" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getDashboard } from '@/api'

export default {
  name: 'Dashboard',
  data() {
    return {
      stats: {},
      recentOrders: [],
      salesChart: null
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const res = await getDashboard()
        this.stats = res.stats || res || {}
        this.recentOrders = res.recentOrders || []
        this.$nextTick(() => this.initChart())
      } catch (e) {
        console.error('加载首页数据失败:', e)
      }
    },
    initChart() {
      if (this.salesChart) this.salesChart.dispose()
      const chartDom = this.$refs.salesChart
      if (!chartDom) return
      this.salesChart = echarts.init(chartDom)
      const days = this.stats.saleDays || ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
      const values = this.stats.saleValues || [0, 0, 0, 0, 0, 0, 0]
      this.salesChart.setOption({
        tooltip: { trigger: 'axis' },
        xAxis: { type: 'category', data: days },
        yAxis: { type: 'value' },
        series: [{
          data: values,
          type: 'line',
          smooth: true,
          lineStyle: { color: '#3a8ee6' },
          itemStyle: { color: '#3a8ee6' },
          areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(228,57,60,0.3)' },
            { offset: 1, color: 'rgba(228,57,60,0.05)' }
          ])}
        }]
      })
    },
    formatMoney(val) {
      if (!val && val !== 0) return '--'
      return Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    statusType(status) {
      const map = { 0: 'warning', 1: '', 2: 'info', 3: 'success', 4: 'danger' }
      return map[status] || 'info'
    }
  },
  beforeDestroy() {
    if (this.salesChart) this.salesChart.dispose()
  }
}
</script>

<style scoped>
.dashboard { padding: 0; }
.stats-row { margin-bottom: 24px; }
.stat-card { border-radius: 8px; }
.stat-content { display: flex; justify-content: space-between; align-items: flex-start; }
.stat-info .stat-label { font-size: 13px; color: #909399; margin: 0 0 8px; }
.stat-info .stat-value { font-size: 28px; font-weight: bold; color: #303133; margin: 0 0 8px; }
.stat-info .stat-value.red-text { color: #3a8ee6; }
.stat-info .stat-trend { font-size: 12px; margin: 0; }
.stat-info .stat-trend.up { color: #67c23a; }
.stat-info .stat-sub { font-size: 12px; color: #909399; margin: 0; }
.stat-info .stat-link { font-size: 12px; color: #3a8ee6; cursor: pointer; margin: 0; }
.stat-icon { width: 48px; height: 48px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff; }
.stat-icon.red { background: #fde2e2; color: #3a8ee6; }
.stat-icon.blue { background: #e8f4fd; color: #409eff; }
.stat-icon.orange { background: #fef0e6; color: #e6a23c; }
.stat-icon.purple { background: #f3e8ff; color: #a855f7; }
.chart-row { margin-bottom: 24px; }
.chart-card .chart-box { height: 320px; }
.card-header { display: flex; justify-content: space-between; align-items: center; font-weight: bold; }
.order-list { max-height: 320px; overflow-y: auto; }
.order-item { display: flex; justify-content: space-between; align-items: center; padding: 12px 0; border-bottom: 1px solid #f0f0f0; }
.order-item:last-child { border-bottom: none; }
.order-left { display: flex; align-items: center; flex: 1; overflow: hidden; }
.order-img { width: 48px; height: 48px; border-radius: 6px; margin-right: 10px; flex-shrink: 0; }
.order-info { overflow: hidden; }
.order-name { font-size: 13px; font-weight: 500; margin: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.order-no { font-size: 11px; color: #c0c4cc; margin: 4px 0 0; }
.order-right { text-align: right; flex-shrink: 0; margin-left: 12px; }
.order-price { color: #3a8ee6; font-weight: bold; font-size: 14px; margin: 0 0 4px; }
</style>
